/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Connection,
  ConnectionMeter,
  ConnectionUpdatePayload,
  ConnectionsListParams,
  ErrorResponse
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List connections
 */
export const connectionsList = (
    params?: ConnectionsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Connection[]>(
      {url: `/api/connections`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getConnectionsListQueryKey = (params?: ConnectionsListParams,) => {
    return [
    `/api/connections`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getConnectionsListQueryOptions = <TData = Awaited<ReturnType<typeof connectionsList>>, TError = ErrorResponse>(params?: ConnectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConnectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof connectionsList>>> = ({ signal }) => connectionsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConnectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof connectionsList>>>
export type ConnectionsListQueryError = ErrorResponse


export function useConnectionsList<TData = Awaited<ReturnType<typeof connectionsList>>, TError = ErrorResponse>(
 params: undefined |  ConnectionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsList>>,
          TError,
          Awaited<ReturnType<typeof connectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsList<TData = Awaited<ReturnType<typeof connectionsList>>, TError = ErrorResponse>(
 params?: ConnectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsList>>,
          TError,
          Awaited<ReturnType<typeof connectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsList<TData = Awaited<ReturnType<typeof connectionsList>>, TError = ErrorResponse>(
 params?: ConnectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List connections
 */

export function useConnectionsList<TData = Awaited<ReturnType<typeof connectionsList>>, TError = ErrorResponse>(
 params?: ConnectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConnectionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get connection by ID
 */
export const connectionsGet = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Connection>(
      {url: `/api/connections/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getConnectionsGetQueryKey = (id?: number,) => {
    return [
    `/api/connections/${id}`
    ] as const;
    }

    
export const getConnectionsGetQueryOptions = <TData = Awaited<ReturnType<typeof connectionsGet>>, TError = ErrorResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConnectionsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof connectionsGet>>> = ({ signal }) => connectionsGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConnectionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof connectionsGet>>>
export type ConnectionsGetQueryError = ErrorResponse


export function useConnectionsGet<TData = Awaited<ReturnType<typeof connectionsGet>>, TError = ErrorResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsGet>>,
          TError,
          Awaited<ReturnType<typeof connectionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsGet<TData = Awaited<ReturnType<typeof connectionsGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsGet>>,
          TError,
          Awaited<ReturnType<typeof connectionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsGet<TData = Awaited<ReturnType<typeof connectionsGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get connection by ID
 */

export function useConnectionsGet<TData = Awaited<ReturnType<typeof connectionsGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConnectionsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update connection settings
 */
export const connectionsUpdate = (
    id: number,
    connectionUpdatePayload: ConnectionUpdatePayload,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/connections/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: connectionUpdatePayload
    },
      options);
    }
  


export const getConnectionsUpdateMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectionsUpdate>>, TError,{id: number;data: ConnectionUpdatePayload}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof connectionsUpdate>>, TError,{id: number;data: ConnectionUpdatePayload}, TContext> => {

const mutationKey = ['connectionsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectionsUpdate>>, {id: number;data: ConnectionUpdatePayload}> = (props) => {
          const {id,data} = props ?? {};

          return  connectionsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof connectionsUpdate>>>
    export type ConnectionsUpdateMutationBody = ConnectionUpdatePayload
    export type ConnectionsUpdateMutationError = ErrorResponse

    /**
 * @summary Update connection settings
 */
export const useConnectionsUpdate = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectionsUpdate>>, TError,{id: number;data: ConnectionUpdatePayload}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connectionsUpdate>>,
        TError,
        {id: number;data: ConnectionUpdatePayload},
        TContext
      > => {

      const mutationOptions = getConnectionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List meters for a connection
 */
export const connectionsMeters = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectionMeter[]>(
      {url: `/api/connections/${id}/meters`, method: 'GET', signal
    },
      options);
    }
  



export const getConnectionsMetersQueryKey = (id?: number,) => {
    return [
    `/api/connections/${id}/meters`
    ] as const;
    }

    
export const getConnectionsMetersQueryOptions = <TData = Awaited<ReturnType<typeof connectionsMeters>>, TError = ErrorResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConnectionsMetersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof connectionsMeters>>> = ({ signal }) => connectionsMeters(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConnectionsMetersQueryResult = NonNullable<Awaited<ReturnType<typeof connectionsMeters>>>
export type ConnectionsMetersQueryError = ErrorResponse


export function useConnectionsMeters<TData = Awaited<ReturnType<typeof connectionsMeters>>, TError = ErrorResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsMeters>>,
          TError,
          Awaited<ReturnType<typeof connectionsMeters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsMeters<TData = Awaited<ReturnType<typeof connectionsMeters>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof connectionsMeters>>,
          TError,
          Awaited<ReturnType<typeof connectionsMeters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConnectionsMeters<TData = Awaited<ReturnType<typeof connectionsMeters>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List meters for a connection
 */

export function useConnectionsMeters<TData = Awaited<ReturnType<typeof connectionsMeters>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof connectionsMeters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConnectionsMetersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




